import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
import App from './App.tsx'
import './index.css'
import AuthProvider from './contexts/AuthContext';
import { MarketingAssetsProvider } from './lib/marketingAssets';

// Initialize GA4
const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

if (GA_MEASUREMENT_ID) {
  try {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    console.log("[GA4] Initialized with ID:", GA_MEASUREMENT_ID);
    // Optionally send initial pageview if needed, though AnalyticsTracker will handle subsequent ones
    // ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
  } catch (error) {
    console.error("[GA4] Initialization error:", error);
  }
} else {
  console.warn("[GA4] Measurement ID not found (VITE_GA_MEASUREMENT_ID). Analytics will not be sent.");
}

// Register Service Worker only in production
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('Service Worker registered:', registration);

        // Check for updates every 60 minutes
        setInterval(() => {
          registration.update();
          console.log('Checking for service worker updates...');
        }, 60 * 60 * 1000);

        // Handle updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          console.log('Service Worker update found!');

          newWorker?.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('New content is available; please refresh.');
              // Optional: Show a notification to the user about the update
              if (window.confirm('New version available! Reload to update?')) {
                window.location.reload();
              }
            }
          });
        });
      })
      .catch(error => {
        console.log('Service Worker registration failed:', error);
      });

    // Handle controller change (when a new service worker takes over)
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      console.log('New service worker controller, reloading page...');
      window.location.reload();
    });
  });
}

// Render the App component
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <MarketingAssetsProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </MarketingAssetsProvider>
  </React.StrictMode>
);
